<div class="ia-page">
  <div class="page-header">
    <div class="header-left">
      <h1>Improvement Activities</h1>
    </div>
    <div class="header-right">
      @if (relatedOrganizations().length > 0) {
        <div class="chip tin-rollup-chip" [matTooltip]="rollupTooltip" matTooltipPosition="below">
          TIN Roll Up <mat-icon class="rollup-info-icon">info</mat-icon>
        </div>
      } @else {
        <div class="chip">Practice: {{ practice }}</div>
      }
      <div class="chip">Performance Duration: {{ performanceDuration }}</div>
      <div class="chip">TIN: {{ tin }}</div>
    </div>
  </div>

  @if (showTabs) {
    <div class="reporting-tabs">
      <button
        class="tab-btn"
        [class.active]="currentTab === 'traditional'"
        (click)="onTabChange('traditional')"
      >
        Traditional MIPS
      </button>
      <button
        class="tab-btn"
        [class.active]="currentTab === 'mvp'"
        (click)="onTabChange('mvp')"
      >
        MVP
      </button>
    </div>
  }

  @if (!requirementMet && !isInBothMode) {
    <div class="requirement-warning">
      <mat-icon>warning</mat-icon>
      <div class="warning-content">
        You need {{ 40 - estimatedTotal }} more points to meet the requirement.
        @if (hasSpecialStatus) {
          Select and complete 1 activity.
        } @else {
          Select and complete 2 activities.
        }
      </div>
    </div>
  }
  @if (isInBothMode && (!traditionalRequirementMet || !mvpRequirementMet)) {
    <div class="requirement-warning">
      <mat-icon>warning</mat-icon>
      <div class="warning-content">
        @if (!traditionalRequirementMet && !mvpRequirementMet) {
          Both Traditional and MVP requirements must be met. Traditional needs
          {{ 40 - estimatedTotalTraditional }} more points, MVP needs
          {{ 40 - estimatedTotalMvp }} more points.
        } @else if (!traditionalRequirementMet) {
          Traditional requirement not met. Need
          {{ 40 - estimatedTotalTraditional }} more points.
        } @else if (!mvpRequirementMet) {
          MVP requirement not met. Need {{ 40 - estimatedTotalMvp }} more
          points.
        }
      </div>
    </div>
  }

  @if (!isInBothMode) {
    <div class="validation-cards">
      @if (hasSpecialStatus) {
        <div class="card special-status-card">
          <mat-icon class="card-icon-star">star</mat-icon>
          <div class="card-content">
            <div class="card-title">{{ specialStatusText }}</div>
            <div class="card-subtitle">40 points per activity</div>
          </div>
        </div>
      }

      <div class="card" [class.valid]="activitiesSelected >= minimumRequired">
        <div class="card-number">{{ activitiesSelected }}</div>
        <div class="card-content">
          <div class="card-title">Activities Selected</div>
          <div class="card-subtitle">
            (Select Minimum {{ minimumRequired }})
          </div>
        </div>
      </div>

      <div class="points-card">
        <div class="points-section">
          <div class="points-label">
            Estimated IA Points
            <mat-icon
              *ngIf="isScoreCalculating()"
              class="score-calculating-icon"
              matTooltip="Saving — scores will update momentarily"
              matTooltipPosition="above"
            >sync</mat-icon>
          </div>
          <div class="points-calculation">
            <span class="total-value">{{ estimatedTotal }}/40</span>
          </div>
        </div>
        <div class="weight-section">
          <div class="weight-label">Estimated IA Weight</div>
          <div class="weight-value">
            {{ estimatedWeight }}/{{ reweighting().weights.ia }}
            @if (showReweightingIndicator) {
              <mat-icon
                class="reweighting-icon"
                [matTooltip]="reweightingTooltip"
                matTooltipPosition="above"
              >
                info
              </mat-icon>
            }
          </div>
          @if (!showReweightingIndicator) {
            <mat-icon
              class="info-icon"
              matTooltip="Weight calculated as (Total Points / 40) × 15"
              matTooltipPosition="above"
              >info_outline</mat-icon
            >
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="validation-cards-both">
      @if (currentTab === 'traditional' && hasSettingsSpecialStatus) {
        <div class="card special-status-card">
          <mat-icon class="card-icon-star">star</mat-icon>
          <div class="card-content">
            <div class="card-title">{{ specialStatusText }}</div>
            <div class="card-subtitle">40 points per activity</div>
          </div>
        </div>
      } @else if (currentTab === 'mvp') {
        <div class="card special-status-card">
          <mat-icon class="card-icon-star">star</mat-icon>
          <div class="card-content">
            <div class="card-title">MVP Participant</div>
            <div class="card-subtitle">40 points per activity</div>
          </div>
        </div>
      }

      <div class="card" [class.valid]="traditionalRequirementMet">
        <div class="card-number">{{ traditionalSelectedCount }}</div>
        <div class="card-content">
          <div class="card-title">Traditional Activities</div>
          <div class="card-subtitle">(Selected)</div>
        </div>
      </div>

      <div class="card" [class.valid]="mvpRequirementMet">
        <div class="card-number">{{ mvpSelectedCount }}</div>
        <div class="card-content">
          <div class="card-title">MVP Activities</div>
          <div class="card-subtitle">(Selected)</div>
        </div>
      </div>

      <div class="points-card-both">
        <div class="points-section-both">
          <div class="points-label-both">Estimated IA Points</div>
          <div class="points-display-both">
            <div class="points-column">
              <div class="points-type-label">Traditional</div>
              <div
                class="points-value"
                [class.complete]="traditionalRequirementMet"
              >
                {{ estimatedTotalTraditional }}/40
              </div>
            </div>
            <div class="divider-both"></div>
            <div class="points-column">
              <div class="points-type-label">MVP</div>
              <div class="points-value" [class.complete]="mvpRequirementMet">
                {{ estimatedTotalMvp }}/40
              </div>
            </div>
          </div>
        </div>
        <div class="weight-section-both">
          <div class="weight-label-both">Estimated IA Weight</div>
          <div class="weight-display-both">
            <div class="weight-column">
              <div
                class="weight-value"
                [class.complete]="traditionalRequirementMet"
              >
                {{ estimatedWeightTraditional }}/{{ reweighting().weights.ia }}
              </div>
            </div>
            <div class="divider-both"></div>
            <div class="weight-column">
              <div class="weight-value" [class.complete]="mvpRequirementMet">
                {{ estimatedWeightMvp }}/{{ reweighting().weights.ia }}
              </div>
            </div>
          </div>
          @if (showReweightingIndicator) {
            <mat-icon
              class="reweighting-icon"
              [matTooltip]="reweightingTooltip"
              matTooltipPosition="above"
              >info</mat-icon
            >
          } @else {
            <mat-icon
              class="info-icon"
              matTooltip="Weight calculated as (Total Points / 40) × 15 for each"
              matTooltipPosition="above"
              >info_outline</mat-icon
            >
          }
        </div>
      </div>
    </div>
  }

  <div class="date-picker-minimal">
    <mat-form-field class="date-field-minimal" appearance="outline">
      <mat-label>Performance Start Date</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        [min]="minDate"
        [max]="maxDate"
        [matDatepickerFilter]="dateFilter"
        [errorStateMatcher]="startDateErrorMatcher"
        [(ngModel)]="performanceStartDate"
        (dateChange)="onPerformanceStartDateChange($event.value)"
        required
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="startPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
      <mat-error *ngIf="performanceStartDateInvalid">
        Performance start date must be within {{ currentPacket()?.performanceYear ?? 2026 }}
      </mat-error>
      <mat-error *ngIf="startDateBeforeEndDateError">
        Start date must be before end date
      </mat-error>
    </mat-form-field>

    <mat-form-field class="date-field-minimal" appearance="outline">
      <mat-label>Performance End Date</mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        [min]="minDate"
        [max]="maxDate"
        [matDatepickerFilter]="dateFilter"
        [errorStateMatcher]="endDateErrorMatcher"
        [(ngModel)]="performanceEndDate"
        (dateChange)="onPerformanceEndDateChange($event.value)"
        required
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="endPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
      <mat-error *ngIf="performanceEndDateInvalid">
        Performance end date must be within {{ currentPacket()?.performanceYear ?? 2026 }}
      </mat-error>
    </mat-form-field>

    @if (dateRangeInvalid && startDateBeforeEndDateError) {
      <div class="date-warning-minimal date-range-error">
        <mat-icon class="warning-icon">warning</mat-icon>
        Start date must be before end date
      </div>
    }

    @if (!performanceStartDate || !performanceEndDate) {
      <div class="date-warning-minimal">Performance dates required</div>
    }
  </div>

  <div class="table-header">
    <div class="th th-checkbox"></div>
    <div class="th th-id">Activity ID</div>
    <div class="th th-description">Activity Description</div>
    <div class="th th-supporting">Supporting Documentation</div>
    <div class="th th-points">Points</div>
  </div>

  @for (category of categories; track category.name) {
    <div class="category-section">
      <div class="category-header-bar" (click)="toggleCategory(category)">
        <span class="category-name">{{ category.name }}</span>
        <mat-icon class="expand-icon">{{
          category.isExpanded ? "expand_less" : "expand_more"
        }}</mat-icon>
      </div>

      @if (category.isExpanded) {
        @for (activity of category.activities; track activity.activityId) {
          <div
            class="activity-row"
            [class.selected]="isActivitySelected(activity)"
          >
            <div class="td td-checkbox">
              <mat-checkbox
                [checked]="isActivitySelected(activity)"
                (change)="onActivityToggle(activity)"
              ></mat-checkbox>
            </div>

            <div class="td td-id">
              <div class="id-content">
                @if (isSuspendedActivity(activity.activityId)) {
                  <mat-icon
                    class="suspended-icon"
                    [matTooltip]="getSuspendedActivityTooltip()"
                    >info</mat-icon
                  >
                }
                @if (activity.documentName) {
                  <mat-icon class="document-badge">description</mat-icon>
                }
                <span class="activity-id-text">{{ activity.activityId }}</span>
              </div>
            </div>

            <div class="td td-description">
              {{ activity.activityDescription }}
            </div>

            <div class="td td-supporting">
              @if (!activity.documentName) {
                <div class="upload-container">
                  @if (!isActivitySelected(activity)) {
                    <div class="upload-disabled-state">
                      <button class="btn-upload" disabled>
                        <mat-icon>upload</mat-icon>
                        <span>Upload</span>
                      </button>
                      <span class="disabled-hint">Select activity first</span>
                    </div>
                  } @else {
                    <label class="btn-upload btn-upload-active">
                      <mat-icon>upload</mat-icon>
                      <span>Upload</span>
                      <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        style="display: none"
                        (change)="onDocumentUpload(activity, $event)"
                      />
                    </label>
                  }
                </div>
              } @else {
                <div class="document-info">
                  <mat-icon class="doc-icon">check_circle</mat-icon>
                  <span class="doc-name" [title]="activity.documentName">{{
                    activity.documentName
                  }}</span>
                  <div class="file-actions-minimal">
                    <button
                      mat-icon-button
                      (click)="viewFile(activity)"
                      matTooltip="View"
                      class="read-only-allowed"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      (click)="downloadFile(activity)"
                      matTooltip="Download"
                      class="read-only-allowed"
                    >
                      <mat-icon>download</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      (click)="removeDocument(activity, $event)"
                      matTooltip="Delete"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>

            <div class="td td-points">{{ getActivityPoints(activity) }}</div>
          </div>

          @if (isActivitySelected(activity)) {
            <div class="activity-status-row">
              <mat-icon class="status-icon">{{
                isActivityIncomplete(activity)
                  ? "radio_button_unchecked"
                  : "check_circle"
              }}</mat-icon>
              <span>{{
                isActivityIncomplete(activity) ? "Incomplete" : "Complete"
              }}</span>
            </div>
          }
        }
      }
    </div>
  }
</div>
